import { khachHangSearchColumns, nhomColumns, QUERY_KEYS, regionColumns } from '@/constants';
import { SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { DoiTuong, KhuVuc, NhomKhachHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface DetailTabProps {
  formMode: FormMode;
  nhaCungCap: DoiTuong | null;
  setNhaCungCap: (nhaCungCap: DoiTuong) => void;
  nhomKH1: NhomKhachHang | null;
  nhomKH2: NhomKhachHang | null;
  nhomKH3: NhomKhachHang | null;
  setNhomKH1: (nhaCungCap: NhomKhachHang) => void;
  setNhomKH2: (nhaCungCap: NhomKhachHang) => void;
  setNhomKH3: (nhaCungCap: NhomKhachHang) => void;
  khuVuc: KhuVuc | null;
  setKhuVuc: (khuVuc: KhuVuc) => void;
}

export const DetailTab: React.FC<DetailTabProps> = ({
  formMode,
  nhaCungCap,
  setNhaCungCap,
  nhomKH1,
  nhomKH2,
  nhomKH3,
  setNhomKH1,
  setNhomKH2,
  setNhomKH3,
  khuVuc,
  setKhuVuc
}) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã nhà cung cấp</Label>
          <SearchField<DoiTuong>
            type='text'
            name='ma_kh'
            searchColumns={khachHangSearchColumns}
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
            dialogTitle='Danh mục đối tượng'
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            classNameRelatedField='w-full'
            onRowSelection={setNhaCungCap}
            value={nhaCungCap?.customer_code || ''}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Nhóm NCC</Label>
          <SearchField<NhomKhachHang>
            searchColumns={nhomColumns}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC1`}
            dialogTitle='Danh mục nhóm khách hàng 1'
            columnDisplay='ma_nhom'
            classNameRelatedField='w-full'
            onRowSelection={setNhomKH1}
            value={nhomKH1?.ma_nhom || ''}
            className='w-fit'
          />
          <SearchField
            searchColumns={nhomColumns}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC2`}
            dialogTitle='Danh mục nhóm khách hàng 2'
            columnDisplay='ma_nhom'
            classNameRelatedField='w-full'
            onRowSelection={setNhomKH2}
            value={nhomKH2?.ma_nhom || ''}
            className='ml-2 w-fit'
          />
          <SearchField
            searchColumns={nhomColumns}
            searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC3`}
            dialogTitle='Danh mục nhóm khách hàng 3'
            columnDisplay='ma_nhom'
            classNameRelatedField='w-full'
            onRowSelection={setNhomKH3}
            value={nhomKH3?.ma_nhom || ''}
            className='ml-2 w-fit'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Khu vực</Label>
          <SearchField<KhuVuc>
            type='text'
            name='rg_code'
            searchColumns={regionColumns}
            searchEndpoint={`/${QUERY_KEYS.KHU_VUC}/`}
            dialogTitle='Danh mục khu vực'
            columnDisplay='rg_code'
            displayRelatedField='rgname'
            classNameRelatedField='w-full'
            onRowSelection={setKhuVuc}
            value={khuVuc?.rg_code || ''}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Chi tiết</Label>
          <div className='w-[350px]'>
            <FormField
              type='select'
              name='ct_theo'
              disabled={formMode === 'view'}
              options={[
                { label: 'Theo hóa đơn', value: '1' },
                { label: 'Theo nhà cung cấp', value: '2' }
              ]}
              defaultValue={'0'}
            />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Số dư</Label>
          <div className='w-[350px]'>
            <FormField
              type='select'
              name='tt_yn'
              disabled={formMode === 'view'}
              options={[
                { label: 'Tất cả', value: '0' },
                { label: 'Chỉ có hóa đơn số dư lớn hơn 0', value: '1' }
              ]}
              defaultValue={'1'}
            />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Số ngày hạn tt</Label>
          <div className='w-[350px]'>
            <FormField type='number' name='so_ngay_tt' disabled={formMode === 'view'} defaultValue={30} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Số ngày cảnh báo</Label>
          <div className='w-[350px]'>
            <FormField type='number' name='so_ngay_cb' disabled={formMode === 'view'} defaultValue={0} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mẫu báo cáo</Label>
          <div className='w-[350px]'>
            <FormField
              type='select'
              name='mau_bc'
              disabled={formMode === 'view'}
              options={[
                { label: 'Mẫu tiền chuẩn', value: '20' },
                { label: 'Mẫu ngoại tệ', value: '30' }
              ]}
              defaultValue={'20'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
